import { validators } from '../utils/validators';

/** Validation schema for client notes (used by NotesTab). */
export const noteFormSchema = {
  content: [validators.required, validators.minLength(1), validators.maxLength(5000)],
};
